import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { NavLink } from "react-router-dom";
import Id from '../../../../../../components/Operation/Id';
import Logo from '../../../../../../components/Operation/Logo';
import PopupOpNote from "../../../../../../components/Popup/PopupOpNote";
import { MAP_ELEMENT } from "../../../../../../contexts/WorldMapContext/constants";
import { selectPermissions } from '../../../../../../util/store/selectors';
import { AppState, useSelector } from "../../../../../../util/store/store";
import { OPERATION_TYPE } from "../../../../../../util/varibles/constants";
import { getOperationStatus } from '../../../../../../util/varibles/global';
import { IOperation, IVessel } from "../../../../../../util/varibles/interface";
import { ACTION } from '../../../../../../util/varibles/permission';
import { dashboardActions } from "../../../../reducer";
import { generateMarkers } from "../../../constants";
import Duration from "./Component/Duration";
import Status from "./Component/Status";
import Event from "./Event";
import Harvest from "./Harvest";
import Service from "./Service";
import styles from "./style.module.scss";
import Transport from "./Transport";
import Treatment from "./Treatment";

const mapStateToProps = (state: AppState) => ({
    target: state.dashboard.target,
    vessels: state.dashboard.vessels,
});

const content: any = {
    [OPERATION_TYPE.HARVEST]: (value: IOperation) => <Harvest {...value} />,
    [OPERATION_TYPE.TREATMENT]: (value: IOperation) => <Treatment {...value} />,
    [OPERATION_TYPE.TRANSPORT]: (value: IOperation) => <Transport {...value} />,
    [OPERATION_TYPE.EVENT]: (value: IOperation) => <Event {...value} />,
    [OPERATION_TYPE.SERVICE]: (value: IOperation) => <Service {...value} />,
}

interface IProps {
    data: IOperation
    target: any
    vessels: IVessel[]

    showInfo(payload: any): void

    updateOperations(payload: any): void
}

const Operation: React.FC<IProps> = (props) => {
    const { data, target, vessels } = props;
    const { operation } = data;
    const { id: selectedId } = target.data?.operation || {};
    const { operation_type, id, note = '', operation_code, event_type, tenant_id, status, pauses = [] } = data.operation;
    const isSelected = id === selectedId;
    const [isShow, setIsShow] = useState(false);
    const [vessel, setVessel] = useState<IVessel | undefined>();
    const [canUpdateOperation] = useSelector(selectPermissions([ACTION.OPERATION.UPDATE]));

    useEffect(() => {
        const { vessel_id } = data.operation;
        setVessel(vessels.find(item => item.id === vessel_id))
    }, [data, vessels]);

    const handleClick = (e: any) => {
        if (e.target.closest(`.${styles.note}`)) {
            setIsShow(true);
            return;
        }

        if (isSelected) {
            props.showInfo({});
        } else {
            const { operation_type } = data.operation;
            const getMarkers = generateMarkers[operation_type];
            const markers = getMarkers ? getMarkers(data) : [];
            const { id: vessel_id = '' } = vessel || {};
            props.showInfo({
                targetType: MAP_ELEMENT.POLYLINE,
                data: { ...data, vessel, markers: [...markers, { type: MAP_ELEMENT.VESSEL, id: vessel_id }] },
            });
        }
    };

    const updateNote = (note: string) => {
        props.updateOperations([{ ...data, operation: { ...data.operation, note } }]);
    }

    const view = content[operation_type];
    const realStatus = getOperationStatus(status, pauses);

    return <div
        className={styles.operation}
        data-is-active={isSelected}
        data-operation-type={operation_type}
        onClick={handleClick}
    >
        <div className={styles['content']}>
            <div className={styles['operation-title']}>
                <Logo status={realStatus} type={operation.operation_type} dataAttribute={{ 'data-event-type': event_type }} />
                <NavLink to={`/operation/${tenant_id}/${id}`}>
                    <Id operation={operation} status={realStatus} />
                </NavLink>
                <Status {...{ operation, activityLog: data.activity_log }} realStatus={realStatus} />
            </div>
            {view?.({ ...data, vessel: vessel || {} })}
            <Duration activity_log={data.activity_log}>
                {note.length > 0 && <div className={styles.note} data-disabled={!canUpdateOperation} onClick={() => {
                    if (canUpdateOperation)
                        setIsShow(true)
                }} />}
            </Duration>
        </div>
        <PopupOpNote {...{
            isShow,
            note,
            info: { code: "#" + operation_code },
            operation,
            handleSave: updateNote,
            handleClose: () => setIsShow(false)
        }} />
    </div>;
};

export default connect(mapStateToProps, {
    showInfo: dashboardActions.showInfo,
    updateOperations: dashboardActions.updateOperations
})(Operation);
